const job_rules = {
    "T0101": {
        "gap": "Lights along path are difficult to turn on",
        "job_group": "facility_access",
        "prob_bit": 1,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0101",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U2 || a.U3 || a.V3 || a.V4 || a.C2)) || ((a.V3 || a.V4 || a.C2)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U2 || a.U3)) || ((a.V3 || a.V4))))"
    },
    "T0102": {
        "gap": "Path is difficult to see",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0102",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.V1 || a.V3))))"
    },
    "T0103": {
        "gap": "Path is sloped or uneven",
        "job_group": "facility_access",
        "prob_bit": 3,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0103",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.V3 || a.V4 || a.V5 || a.V6 || a.H6))))"
    },
    "T0104": {
        "gap": "Path is not wide enough",
        "job_group": "facility_access",
        "prob_bit": 4,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0104",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0105": {
        "gap": "Path is obstructed",
        "job_group": "facility_access",
        "prob_bit": 5,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0105",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8b || a.L8c || a.L8d || a.L8e || a.V3 || a.V4 || a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4))))"
    },
    "T0106": {
        "gap": "Path is too slippery",
        "job_group": "facility_access",
        "prob_bit": 6,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0106",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8a || a.L8b))))"
    },
    "T0107": {
        "gap": "Path offers resistance to movement",
        "job_group": "facility_access",
        "prob_bit": 7,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0107",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0108": {
        "gap": "Route is too long",
        "job_group": "facility_access",
        "prob_bit": 8,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0108",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.L8a || a.L8b || a.L8c))))"
    },
    "T0109": {
        "gap": "Path provides visual distractions",
        "job_group": "facility_access",
        "prob_bit": 9,
        "task": "Moving Through the Workplace",
        "task_bit": 1,
        "task_code": "T0109",
        "trigger": "(a.facility_access && a.moving_through_the_workplace && (((a.V3 || a.V4 || a.C1 || a.A1)) || ((a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.C1 || a.A1))))"
    },
    "T0201": {
        "gap": "Correct door key is difficult to identify",
        "job_group": "facility_access",
        "prob_bit": 1,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0201",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.V3 || a.V4 || a.V5 || a.V6 || a.H6 || a.C2))))"
    },
    "T0202": {
        "gap": "Door lock is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0202",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.V3 || a.V4 || a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4)) || ((a.V3 || a.V4 || a.V5 || a.V6))))"
    },
    "T0203": {
        "gap": "Door lock is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 3,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0203",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3))))"
    },
    "T0204": {
        "gap": "Key is difficult to grip, hold",
        "job_group": "facility_access",
        "prob_bit": 4,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0204",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12))))"
    },
    "T0205": {
        "gap": "Key is difficult to turn, push, pull",
        "job_group": "facility_access",
        "prob_bit": 5,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0205",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12))))"
    },
    "T0206": {
        "gap": "Door access button or key reader is difficult to locate ",
        "job_group": "facility_access",
        "prob_bit": 6,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0206",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.V3 || a.V4 || a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4))))"
    },
    "T0207": {
        "gap": "Door access button or key reader is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 7,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0207",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3))))"
    },
    "T0208": {
        "gap": "Door access button is difficult to operate due to size, shape, or force",
        "job_group": "facility_access",
        "prob_bit": 8,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0208",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.U1 || a.U2)) || ((a.U1 || a.U2 || a.U10 || a.U11)) || ((a.U10 || a.U11))))"
    },
    "T0209": {
        "gap": "Door key card reader is difficult to operate due to shape or swiping movement",
        "job_group": "facility_access",
        "prob_bit": 9,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0209",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.U1 || a.U2 || a.U10 || a.U11)) || ((a.U1 || a.U2 || a.U3 || a.U10 || a.U11 || a.U12))))"
    },
    "T0210": {
        "gap": "Unlocking process is difficult to remember ",
        "job_group": "facility_access",
        "prob_bit": 10,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0210",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.C2))))"
    },
    "T0211": {
        "gap": "Door is difficult to see ",
        "job_group": "facility_access",
        "prob_bit": 11,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0211",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.V3 || a.V4)) || ((a.V2 || a.V3 || a.V4)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T0212": {
        "gap": "Door handle is difficult to operate (e.g., grip, turn)",
        "job_group": "facility_access",
        "prob_bit": 12,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0212",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12))))"
    },
    "T0213": {
        "gap": "Door handle is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 13,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0213",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3))))"
    },
    "T0214": {
        "gap": "Door is too heavy",
        "job_group": "facility_access",
        "prob_bit": 14,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0214",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0215": {
        "gap": "Door closes too fast",
        "job_group": "facility_access",
        "prob_bit": 15,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0215",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e)) || ((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.V5 || a.V6 || a.H6))))"
    },
    "T0216": {
        "gap": "Door opening is too narrow",
        "job_group": "facility_access",
        "prob_bit": 16,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0216",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0217": {
        "gap": "Threshold is too high",
        "job_group": "facility_access",
        "prob_bit": 17,
        "task": "Unlocking and Using Doors",
        "task_bit": 2,
        "task_code": "T0217",
        "trigger": "(a.facility_access && a.unlocking_and_using_doors && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0301": {
        "gap": "Person cannot use stairs due to mobility limitations ",
        "job_group": "facility_access",
        "prob_bit": 1,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0301",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0302": {
        "gap": "Stair rise is too high",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0302",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8a || a.L8b))))"
    },
    "T0303": {
        "gap": "Stairs are not deep enough",
        "job_group": "facility_access",
        "prob_bit": 3,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0303",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8a || a.L8b)) || ((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e)) || ((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0304": {
        "gap": "Existing ramp is too steep ",
        "job_group": "facility_access",
        "prob_bit": 4,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0304",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0305": {
        "gap": "Existing ramp is too long, without adequate level landings ",
        "job_group": "facility_access",
        "prob_bit": 5,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0305",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8a || a.L8b || a.L8c || a.L8d || a.L8e)) || ((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0306": {
        "gap": "Existing ramp is too narrow ",
        "job_group": "facility_access",
        "prob_bit": 6,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0306",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0307": {
        "gap": "Stairs or ramp are too slippery",
        "job_group": "facility_access",
        "prob_bit": 7,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0307",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L4 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0308": {
        "gap": "Staircase / individual steps are difficult to see",
        "job_group": "facility_access",
        "prob_bit": 8,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0308",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.V3 || a.V4)) || ((a.V1 || a.V3 || a.V4)) || ((a.V3 || a.V4 || a.V5 || a.V6 || a.H6))))"
    },
    "T0309": {
        "gap": "Stair or ramp handrail is not available",
        "job_group": "facility_access",
        "prob_bit": 9,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0309",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L4 || a.L7 || a.L8a || a.L8b))))"
    },
    "T0310": {
        "gap": "Stair or ramp handrail is difficult to reach and pull / push on",
        "job_group": "facility_access",
        "prob_bit": 10,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0310",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L4 || a.L7 || a.L8a || a.L8b || a.U1 || a.U4 || a.U5))))"
    },
    "T0311": {
        "gap": "Stair or ramp handrail is difficult to grip",
        "job_group": "facility_access",
        "prob_bit": 11,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0311",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L4 || a.L7 || a.L8a || a.L8b || a.U10 || a.U13 || a.U14))))"
    },
    "T0312": {
        "gap": "Stair or ramp handrail is difficult to see",
        "job_group": "facility_access",
        "prob_bit": 12,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0312",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.V1 || a.V3 || a.V4))))"
    },
    "T0313": {
        "gap": "Elevator / arrival of elevator is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 13,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0313",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.V1 || a.V3 || a.V4)) || ((a.H1 || a.H2 || a.H3)) || ((a.V1 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3))))"
    },
    "T0314": {
        "gap": "In the elevator, arrival at a particular floor is difficult to recognize",
        "job_group": "facility_access",
        "prob_bit": 14,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0314",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.V1 || a.V3 || a.V4)) || ((a.V1 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3))))"
    },
    "T0315": {
        "gap": "Elevator controls are difficult to see",
        "job_group": "facility_access",
        "prob_bit": 15,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0315",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.V1 || a.V3 || a.V4))))"
    },
    "T0316": {
        "gap": "Elevator controls are difficult to operate due to location, size, or force",
        "job_group": "facility_access",
        "prob_bit": 16,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0316",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U4 || a.U5)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U4 || a.U5 || a.U10 || a.U11 || a.U13 || a.U14))))"
    },
    "T0317": {
        "gap": "Elevator is difficult to enter / exit due to size",
        "job_group": "facility_access",
        "prob_bit": 17,
        "task": "Moving Between Floors",
        "task_bit": 3,
        "task_code": "T0317",
        "trigger": "(a.facility_access && a.moving_between_floors && (((a.L8c || a.L8d || a.L8e))))"
    },
    "T0401": {
        "gap": "The path is difficult to follow",
        "job_group": "facility_access",
        "prob_bit": 1,
        "task": "Navigating the Workplace",
        "task_bit": 4,
        "task_code": "T0401",
        "trigger": "(a.facility_access && a.navigating_the_workplace && (((a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4 || a.V5 || a.C2)) || ((a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H6 || a.C2 || a.C6)) || ((!a.V2) && (!a.V5) && (!a.V6) && (!a.H6) && (a.C2))))"
    },
    "T0402": {
        "gap": "Locations are difficult to identify",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Navigating the Workplace",
        "task_bit": 4,
        "task_code": "T0402",
        "trigger": "(a.facility_access && a.navigating_the_workplace && (((a.C2)) || ((a.V3 || a.V4 || a.V5 || a.C2)) || ((a.V3)) || ((!a.V2) && (!a.V5) && (!a.V6) && (!a.H6) && (a.C2 || a.C6)) || ((!a.V5) && (!a.V6) && (!a.H6) && (a.C2 || a.C6)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T0502": {
        "gap": "Path is too slippery",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0502",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.L4 || a.L8a || a.L8b || a.V3 || a.V4 || a.V5 || a.V6 || a.H6)) || ((a.L4 || a.L8a || a.L8b))))"
    },
    "T0505": {
        "gap": "Toilet is difficult to approach",
        "job_group": "facility_access",
        "prob_bit": 5,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0505",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0506": {
        "gap": "Toilet or urinal is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 6,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0506",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.V3 || a.V4)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T0507": {
        "gap": "Toilet is difficult to transfer on / off",
        "job_group": "facility_access",
        "prob_bit": 7,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0507",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.L4 || a.L5 || a.L6 || a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T0508": {
        "gap": "Flush mechanism is difficult to operate / reach",
        "job_group": "facility_access",
        "prob_bit": 8,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0508",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.L8b || a.L8c || a.L8d || a.L8e)) || ((a.L8b || a.L8c || a.L8d || a.L8e || a.U10 || a.U11))))"
    },
    "T0509": {
        "gap": "Toilet tissue is difficult to acquire (locate, reach, grip)",
        "job_group": "facility_access",
        "prob_bit": 9,
        "task": "Using the Restroom",
        "task_bit": 5,
        "task_code": "T0509",
        "trigger": "(a.facility_access && a.using_the_restroom && (((a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.V3 || a.V4)) || ((a.U10 || a.U11)) || ((a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U10 || a.U11 || a.U12))))"
    },
    "T0601": {
        "gap": "Restroom sink is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 1,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0601",
        "trigger": "(a.facility_access && a.washing_hands && (((a.V3 || a.V4)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T0602": {
        "gap": "Sink is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 2,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0602",
        "trigger": "(a.facility_access && a.washing_hands && (((a.L8b || a.L8c || a.L8d || a.L8e)) || ((a.L8c || a.L8d || a.L8e))))"
    },
    "T0603": {
        "gap": "Sink controls are difficult to operate",
        "job_group": "facility_access",
        "prob_bit": 3,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0603",
        "trigger": "(a.facility_access && a.washing_hands && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12)) || ((a.V3 || a.V4 || a.V5 || a.V6 || a.H6 || a.C2 || a.C6))))"
    },
    "T0604": {
        "gap": "Soap dispenser is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 4,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0604",
        "trigger": "(a.facility_access && a.washing_hands && (((a.V3 || a.V4)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T0605": {
        "gap": "Soap dispenser is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 5,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0605",
        "trigger": "(a.facility_access && a.washing_hands && (((a.L8c || a.L8d || a.L8e || a.U1 || a.U2))))"
    },
    "T0606": {
        "gap": "Soap dispenser is difficult to operate",
        "job_group": "facility_access",
        "prob_bit": 6,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0606",
        "trigger": "(a.facility_access && a.washing_hands && (((a.U10 || a.U11))))"
    },
    "T0607": {
        "gap": "Paper towel dispenser or hand dryer is difficult to locate",
        "job_group": "facility_access",
        "prob_bit": 7,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0607",
        "trigger": "(a.facility_access && a.washing_hands && (((a.V3 || a.V4))))"
    },
    "T0608": {
        "gap": "Paper towel dispenser or hand dryer is difficult to reach",
        "job_group": "facility_access",
        "prob_bit": 8,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0608",
        "trigger": "(a.facility_access && a.washing_hands && (((a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2))))"
    },
    "T0609": {
        "gap": "Hand dryer control is difficult to operate",
        "job_group": "facility_access",
        "prob_bit": 9,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0609",
        "trigger": "(a.facility_access && a.washing_hands && (((a.U10 || a.U11 || a.U12)) || ((a.U10 || a.U11))))"
    },
    "T0610": {
        "gap": "Paper towel dispenser is difficult to operate",
        "job_group": "facility_access",
        "prob_bit": 10,
        "task": "Washing Hands",
        "task_bit": 6,
        "task_code": "T0610",
        "trigger": "(a.facility_access && a.washing_hands && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12))))"
    },
    "T2101": {
        "gap": "It is difficult to get in/out of the work chair because it moves too easily",
        "job_group": "workstation",
        "prob_bit": 1,
        "task": "Getting in/out of Work Chair",
        "task_bit": 21,
        "task_code": "T2101",
        "trigger": "(a.workstation && a.getting_inout_of_work_chair && (((a.L4 || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((!a.L2) && (!a.L4) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e) && (a.U1 || a.U2)) || ((a.L8c || a.L8d || a.L8e))))"
    },
    "T2102": {
        "gap": "The office chair is difficult to pull out or slide in",
        "job_group": "workstation",
        "prob_bit": 2,
        "task": "Getting in/out of Work Chair",
        "task_bit": 21,
        "task_code": "T2102",
        "trigger": "(a.workstation && a.getting_inout_of_work_chair && (((a.L4 || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2)) || ((a.L8c || a.L8d || a.L8e))))"
    },
    "T2103": {
        "gap": "The sitting / standing process is difficult",
        "job_group": "workstation",
        "prob_bit": 3,
        "task": "Getting in/out of Work Chair",
        "task_bit": 21,
        "task_code": "T2103",
        "trigger": "(a.workstation && a.getting_inout_of_work_chair && (((a.L3 || a.L8c || a.L8d || a.L8e))))"
    },
    "T2104": {
        "gap": "It is difficult to transfer to a work chair because the chair's armrests get in the way",
        "job_group": "workstation",
        "prob_bit": 4,
        "task": "Getting in/out of Work Chair",
        "task_bit": 21,
        "task_code": "T2104",
        "trigger": "(a.workstation && a.getting_inout_of_work_chair && (((a.L8c || a.L8d || a.L8e))))"
    },
    "T3101": {
        "gap": "Difficulty remembering appointments or meetings",
        "job_group": "organization",
        "prob_bit": 1,
        "task": "Planning the Work Day",
        "task_bit": 31,
        "task_code": "T3101",
        "trigger": "(a.organization && a.planning_the_work_day && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T3102": {
        "gap": "Difficulty with time management (e.g., getting things done on time)",
        "job_group": "organization",
        "prob_bit": 2,
        "task": "Planning the Work Day",
        "task_bit": 31,
        "task_code": "T3102",
        "trigger": "(a.organization && a.planning_the_work_day && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6))))"
    },
    "T3103": {
        "gap": "Difficulty using standard time management systems",
        "job_group": "organization",
        "prob_bit": 3,
        "task": "Planning the Work Day",
        "task_bit": 31,
        "task_code": "T3103",
        "trigger": "(a.organization && a.planning_the_work_day && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.S5)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.Ha || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5) && (!a.C7)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.Ha || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.C7)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V2) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.V5 || a.V6 || a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T3104": {
        "gap": "Difficulty separating or balancing work and home activities when teleworking",
        "job_group": "organization",
        "prob_bit": 4,
        "task": "Planning the Work Day",
        "task_bit": 31,
        "task_code": "T3104",
        "trigger": "(a.organization && a.planning_the_work_day && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T3201": {
        "gap": "Difficulty identifying / remembering steps in an assigned task",
        "job_group": "organization",
        "prob_bit": 1,
        "task": "Learning / Remembering How to Perform Specific Tasks or Procedures",
        "task_bit": 32,
        "task_code": "T3201",
        "trigger": "(a.organization && a.learning_remembering_how_to_perform_specific_tasks_or_procedures && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.C7)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.C7)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6))))"
    },
    "T3202": {
        "gap": "Difficulty remembering specific information needed to complete a task",
        "job_group": "organization",
        "prob_bit": 2,
        "task": "Learning / Remembering How to Perform Specific Tasks or Procedures",
        "task_bit": 32,
        "task_code": "T3202",
        "trigger": "(a.organization && a.learning_remembering_how_to_perform_specific_tasks_or_procedures && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5) && (!a.C7))))"
    },
    "T3203": {
        "gap": "Difficulty accessing on-the-job training",
        "job_group": "organization",
        "prob_bit": 3,
        "task": "Learning / Remembering How to Perform Specific Tasks or Procedures",
        "task_bit": 32,
        "task_code": "T3203",
        "trigger": "(a.organization && a.learning_remembering_how_to_perform_specific_tasks_or_procedures && (((a.V6 || a.H4 || a.H5 || a.H6 || a.C1 || a.C7)) || ((a.V3 || a.V4 || a.V5 || a.V6 || a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T3301": {
        "gap": "Difficulty remaining focused on task",
        "job_group": "organization",
        "prob_bit": 1,
        "task": "Staying on Task",
        "task_bit": 33,
        "task_code": "T3301",
        "trigger": "(a.organization && a.staying_on_task && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U10 || a.U13 || a.U14 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.U11) && (!a.U12) && (!a.U15) && (!a.U16) && (!a.U17) && (!a.U18)) || ((a.L1 || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.L3) && (!a.L4) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e)) || ((!a.L3) && (!a.L4) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e) && (a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((!a.L7) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e) && (a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T4101": {
        "gap": "Employee is not able to understand the speech of communication partners in face-to-face communication",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Hearing Speech",
        "task_bit": 41,
        "task_code": "T4101",
        "trigger": "(a.communication && a.hearing_speech && (((a.V6 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.Hb || a.Hc || a.Hd)) || ((a.H2 || a.H3 || a.H4 || a.H5 || a.Hb)) || ((a.V6 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.Ha || a.Hb || a.Hc || a.Hd)) || ((a.H2 || a.H3 || a.H4 || a.H5 || a.Ha || a.Hb || a.Hc)) || ((a.H2 || a.H3 || a.H4 || a.H5 || a.Ha)) || ((a.H3 || a.H4 || a.Ha))))"
    },
    "T4201": {
        "gap": "Employee's speech is slurred or distorted",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Producing Speech",
        "task_bit": 42,
        "task_code": "T4201",
        "trigger": "(a.communication && a.producing_speech && (((a.S2 || a.S4))))"
    },
    "T4202": {
        "gap": "Employee's voice is too soft or weak",
        "job_group": "communication",
        "prob_bit": 2,
        "task": "Producing Speech",
        "task_bit": 42,
        "task_code": "T4202",
        "trigger": "(a.communication && a.producing_speech && (((a.S3))))"
    },
    "T4203": {
        "gap": "Employee's voice is hoarse",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Producing Speech",
        "task_bit": 42,
        "task_code": "T4203",
        "trigger": "(a.communication && a.producing_speech && (((a.S3))))"
    },
    "T4204": {
        "gap": "Employee has difficulties with stuttering",
        "job_group": "communication",
        "prob_bit": 4,
        "task": "Producing Speech",
        "task_bit": 42,
        "task_code": "T4204",
        "trigger": "(a.communication && a.producing_speech && (((a.S2))))"
    },
    "T4301": {
        "gap": "The employee has difficulty understanding what is said",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Understanding Communication",
        "task_bit": 43,
        "task_code": "T4301",
        "trigger": "(a.communication && a.understanding_communication && (((a.H3 || a.H4 || a.C1 || a.C2 || a.C7))))"
    },
    "T4303": {
        "gap": "Employee has difficulty staying focused upon what is being said",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Understanding Communication",
        "task_bit": 43,
        "task_code": "T4303",
        "trigger": "(a.communication && a.understanding_communication && (((a.C1 || a.C2 || a.C3 || a.C4 || a.C7 || a.A1))))"
    },
    "T4304": {
        "gap": "Employee has difficulty remembering what has been said",
        "job_group": "communication",
        "prob_bit": 4,
        "task": "Understanding Communication",
        "task_bit": 43,
        "task_code": "T4304",
        "trigger": "(a.communication && a.understanding_communication && (((a.C1 || a.C2 || a.C7))))"
    },
    "T4401": {
        "gap": "Employee has difficulty spontaneously composing statements or questions",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4401",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.S1 || a.C2 || a.C3 || a.C4 || a.A1))))"
    },
    "T4402": {
        "gap": "Employee has difficulty spontaneously answering questions ",
        "job_group": "communication",
        "prob_bit": 2,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4402",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.S1 || a.C1 || a.C2 || a.C3 || a.C4 || a.C7 || a.C8 || a.A1))))"
    },
    "T4403": {
        "gap": "Employee does not know what question to ask when in need of help (or how to ask for help)",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4403",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.S1 || a.C2 || a.C4 || a.C7 || a.C8))))"
    },
    "T4404": {
        "gap": "Employee has trouble coming up with words they want to say",
        "job_group": "communication",
        "prob_bit": 4,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4404",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.S1 || a.C3 || a.C4 || a.A1))))"
    },
    "T4405": {
        "gap": "Employee has difficulty engaging in a reciprocal discussion",
        "job_group": "communication",
        "prob_bit": 5,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4405",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.S1 || a.C1 || a.C2 || a.C3 || a.C4 || a.C8 || a.A1)) || ((a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C8 || a.A1))))"
    },
    "T4406": {
        "gap": "Employee has difficulty staying on topic",
        "job_group": "communication",
        "prob_bit": 6,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4406",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.C1 || a.C2 || a.C4 || a.C8))))"
    },
    "T4407": {
        "gap": "Employee has difficulty giving information in an organized manner",
        "job_group": "communication",
        "prob_bit": 7,
        "task": "Expressing Ideas and Thoughts",
        "task_bit": 44,
        "task_code": "T4407",
        "trigger": "(a.communication && a.expressing_ideas_and_thoughts && (((a.C1 || a.C4 || a.A1))))"
    },
    "T4501": {
        "gap": "Employee makes comments that are not related to the context of the conversation",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Socially / Situationally Appropriate Communication",
        "task_bit": 45,
        "task_code": "T4501",
        "trigger": "(a.communication && a.socially_situationally_appropriate_communication && (((a.S1 || a.C1 || a.C2 || a.C3 || a.C4 || a.C8 || a.A1))))"
    },
    "T4502": {
        "gap": "Employee often misunderstands comments made by others",
        "job_group": "communication",
        "prob_bit": 2,
        "task": "Socially / Situationally Appropriate Communication",
        "task_bit": 45,
        "task_code": "T4502",
        "trigger": "(a.communication && a.socially_situationally_appropriate_communication && (((a.C1 || a.C3 || a.C7 || a.C8 || a.A1))))"
    },
    "T4503": {
        "gap": "Employee has difficulty offering help or demonstrating cooperation",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Socially / Situationally Appropriate Communication",
        "task_bit": 45,
        "task_code": "T4503",
        "trigger": "(a.communication && a.socially_situationally_appropriate_communication && (((a.S1 || a.C2 || a.C3 || a.C4 || a.C8))))"
    },
    "T4504": {
        "gap": "Employee's conversation is sometimes disrespectful to the environment or communication partner",
        "job_group": "communication",
        "prob_bit": 4,
        "task": "Socially / Situationally Appropriate Communication",
        "task_bit": 45,
        "task_code": "T4504",
        "trigger": "(a.communication && a.socially_situationally_appropriate_communication && (((a.S1 || a.C3 || a.C8 || a.A1))))"
    },
    "T4505": {
        "gap": "Employee does not recognize the reactions of the conversation partner and speaks inappropriately",
        "job_group": "communication",
        "prob_bit": 5,
        "task": "Socially / Situationally Appropriate Communication",
        "task_bit": 45,
        "task_code": "T4505",
        "trigger": "(a.communication && a.socially_situationally_appropriate_communication && (((a.C1 || a.C7 || a.C8))))"
    },
    "T4601": {
        "gap": "Pages are difficult to hold / turn",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4601",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U1 || a.U2 || a.U3 || a.U10 || a.U11 || a.U12) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.U10 || a.U11 || a.U12) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.U1 || a.U2 || a.U3 || a.U10 || a.U11 || a.U12))))"
    },
    "T4602": {
        "gap": "Paper slides while writing",
        "job_group": "communication",
        "prob_bit": 2,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4602",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U6 || a.U7 || a.U8 || a.U9))))"
    },
    "T4603": {
        "gap": "Handwriting causes discomfort / pain",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4603",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U1 || a.U10)) || ((a.U10)) || ((a.U1 || a.U10) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.U1 || a.U10) && (!a.S5)) || ((a.U1 || a.U10) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T4604": {
        "gap": "Handwriting requires too much fine motor coordination",
        "job_group": "communication",
        "prob_bit": 4,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4604",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T4605": {
        "gap": "Writing is not legible",
        "job_group": "communication",
        "prob_bit": 5,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4605",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U10 || a.U11)) || ((a.C6)) || ((a.U10 || a.U11 || a.U12 || a.C6)) || ((a.U10 || a.U11 || a.U12 || a.C6) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.U10 || a.U11 || a.U12 || a.C6) && (!a.S5)) || ((a.U10 || a.U11 || a.U12 || a.C6) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T4606": {
        "gap": "Standard pen is too difficult to hold",
        "job_group": "communication",
        "prob_bit": 6,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4606",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U10 || a.U11)) || ((a.U10 || a.U11 || a.U12)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T4607": {
        "gap": "Handwriting is too slow",
        "job_group": "communication",
        "prob_bit": 7,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4607",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.U10 || a.U11 || a.U12)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.S5)) || ((a.U10 || a.U11 || a.U12) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T4608": {
        "gap": "Text is too small",
        "job_group": "communication",
        "prob_bit": 8,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4608",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.V3)) || ((a.V3) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.V3) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5))))"
    },
    "T4609": {
        "gap": "Only part of the page is visible",
        "job_group": "communication",
        "prob_bit": 9,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4609",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.V4)) || ((a.V4) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.V4) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5))))"
    },
    "T4610": {
        "gap": "Documents cannot be seen",
        "job_group": "communication",
        "prob_bit": 10,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4610",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.V5 || a.V6 || a.H6) && (!a.H5)) || ((a.V5)) || ((a.V5) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5)) || ((a.V5) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T4611": {
        "gap": "Writing areas (form blanks) are not visible",
        "job_group": "communication",
        "prob_bit": 11,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4611",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4 || a.V5) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5))))"
    },
    "T4612": {
        "gap": "Employee has difficulty with literacy",
        "job_group": "communication",
        "prob_bit": 12,
        "task": "Reading & Writing Documents",
        "task_bit": 46,
        "task_code": "T4612",
        "trigger": "(a.communication && a.reading_writing_documents && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.S5)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6) && (!a.S5))))"
    },
    "T4701": {
        "gap": "Writing contains misspellings or grammar mistakes",
        "job_group": "communication",
        "prob_bit": 1,
        "task": "Composing Text",
        "task_bit": 47,
        "task_code": "T4701",
        "trigger": "(a.communication && a.composing_text && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.H1 || a.H2 || a.H3 || a.H4 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.S5)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T4702": {
        "gap": "Employee has difficulty thinking of the right words to use",
        "job_group": "communication",
        "prob_bit": 2,
        "task": "Composing Text",
        "task_bit": 47,
        "task_code": "T4702",
        "trigger": "(a.communication && a.composing_text && (((a.S1 || a.C2)) || ((!a.V5) && (!a.V6) && (!a.H6) && (a.S1 || a.C2))))"
    },
    "T4703": {
        "gap": "Writing is not organized",
        "job_group": "communication",
        "prob_bit": 3,
        "task": "Composing Text",
        "task_bit": 47,
        "task_code": "T4703",
        "trigger": "(a.communication && a.composing_text && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    },
    "T6101": {
        "gap": "Keyboard is too far away ",
        "job_group": "equipment",
        "prob_bit": 1,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6101",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U5 || a.U6 || a.U7)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9))))"
    },
    "T6102": {
        "gap": "Cannot hit keys at same time (e.g., Shift-Letter)",
        "job_group": "equipment",
        "prob_bit": 2,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6102",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U12 || a.U15 || a.U16 || a.U17))))"
    },
    "T6103": {
        "gap": "Cannot reach all of the keys",
        "job_group": "equipment",
        "prob_bit": 3,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6103",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U12 || a.U13 || a.U15 || a.U17) && (!a.C2)) || ((a.U10 || a.U11 || a.U12 || a.U13 || a.U15 || a.U17)) || ((a.U11 || a.U12 || a.U13 || a.U15 || a.U17)) || ((a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5))))"
    },
    "T6104": {
        "gap": "Key press requires too much force ",
        "job_group": "equipment",
        "prob_bit": 4,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6104",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U10 || a.U11 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17)) || ((a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5))))"
    },
    "T6105": {
        "gap": "Unwanted keys selected (e.g., from tremor)",
        "job_group": "equipment",
        "prob_bit": 5,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6105",
        "trigger": "(a.equipment && a.using_a_computer && (((!a.U3) && (!a.U9) && (a.U10 || a.U11 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17)) || ((a.U10 || a.U11 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17)) || ((a.U11 || a.U16)) || ((a.U18)) || ((a.U2 || a.U3 || a.U7 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5))))"
    },
    "T6106": {
        "gap": "Typing causes hand / wrist / arm pain or fatigue",
        "job_group": "equipment",
        "prob_bit": 6,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6106",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U5 || a.U6 || a.U7)) || ((a.U1 || a.U4 || a.U5 || a.U10 || a.U13 || a.U14)) || ((a.U10 || a.U13 || a.U14)) || ((a.U12 || a.U13 || a.U15 || a.U17) && (!a.C2)) || ((a.U2 || a.U3 || a.U7 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5))))"
    },
    "T6107": {
        "gap": "Typing is too slow",
        "job_group": "equipment",
        "prob_bit": 7,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6107",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U2 || a.U3 || a.U7 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5)) || ((a.U16 || a.U17 || a.U18))))"
    },
    "T6108": {
        "gap": "Hands-free typing method is needed ",
        "job_group": "equipment",
        "prob_bit": 8,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6108",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U2 || a.U3 || a.U7 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5)) || ((a.U9 || a.U18)) || ((a.U9 || a.U18) && (!a.C2))))"
    },
    "T6109": {
        "gap": "Difficulty changing focus between keyboard and screen ",
        "job_group": "equipment",
        "prob_bit": 9,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6109",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V5 || a.V6 || a.H6)) || ((a.V3))))"
    },
    "T6110": {
        "gap": "Key labels are difficult to see",
        "job_group": "equipment",
        "prob_bit": 10,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6110",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V5 || a.V6 || a.H6)) || ((a.V3)) || ((!a.V1) && (a.V3)) || ((a.V5 || a.V6 || a.H6)) || ((a.V3 || a.V4)) || ((a.V1 || a.V3))))"
    },
    "T6111": {
        "gap": "Key layout is confusing",
        "job_group": "equipment",
        "prob_bit": 11,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6111",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V5 || a.V6 || a.H6 || a.C1 || a.C6)) || ((a.V3 || a.V5 || a.V6 || a.H6 || a.C1 || a.C2 || a.C6)) || ((a.V5 || a.V6 || a.H6))))"
    },
    "T6112": {
        "gap": "Mouse is positioned too far away",
        "job_group": "equipment",
        "prob_bit": 12,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6112",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U1 || a.U4)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6))))"
    },
    "T6113": {
        "gap": "Mouse is difficult to grasp",
        "job_group": "equipment",
        "prob_bit": 13,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6113",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U10 || a.U13)) || ((a.U10 || a.U11 || a.U13 || a.U14 || a.U15))))"
    },
    "T6114": {
        "gap": "Mouse use causes hand/ wrist/ arm pain",
        "job_group": "equipment",
        "prob_bit": 14,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6114",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U1 || a.U4 || a.U10 || a.U13)) || ((a.U10 || a.U11 || a.U13 || a.U14 || a.U15)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6)) || ((a.U2 || a.U3 || a.U7 || a.U9 || a.U11 || a.U12 || a.U18)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6 || a.U10 || a.U11 || a.U13 || a.U14 || a.U15)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5))))"
    },
    "T6115": {
        "gap": "Mouse requires too much motion / strength",
        "job_group": "equipment",
        "prob_bit": 15,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6115",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U1 || a.U4 || a.U10 || a.U13)) || ((a.U2 || a.U3 || a.U7 || a.U9 || a.U11 || a.U12 || a.U18)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6 || a.U10 || a.U11 || a.U13 || a.U14 || a.U15)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18) && (!a.S5)) || ((a.U3 || a.U9 || a.U12 || a.U18))))"
    },
    "T6116": {
        "gap": "Cursor cannot be positioned with sufficient precision",
        "job_group": "equipment",
        "prob_bit": 16,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6116",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U2 || a.U3 || a.U7 || a.U9 || a.U11 || a.U12 || a.U18)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6 || a.U10 || a.U11 || a.U13 || a.U14 || a.U15))))"
    },
    "T6117": {
        "gap": "Device buttons are too hard to push or hold down",
        "job_group": "equipment",
        "prob_bit": 17,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6117",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U2 || a.U3 || a.U7 || a.U9 || a.U11 || a.U12 || a.U18)) || ((a.U1 || a.U2 || a.U4 || a.U5 || a.U6 || a.U10 || a.U11 || a.U13 || a.U14 || a.U15))))"
    },
    "T6118": {
        "gap": "Hands-free cursor control method is needed",
        "job_group": "equipment",
        "prob_bit": 18,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6118",
        "trigger": "(a.equipment && a.using_a_computer && (((a.U3 || a.U9 || a.U12 || a.U18)) || ((a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18)) || ((a.U2 || a.U3 || a.U7 || a.U9 || a.U11 || a.U12 || a.U18)) || ((a.U3 || a.U9 || a.U12 || a.U18 || a.V1))))"
    },
    "T6119": {
        "gap": "Mouse cursor is difficult to track ",
        "job_group": "equipment",
        "prob_bit": 19,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6119",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V4 || a.C1 || a.C6))))"
    },
    "T6120": {
        "gap": "Difficulty using a mouse to make menu selections",
        "job_group": "equipment",
        "prob_bit": 20,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6120",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V4 || a.V5 || a.V6 || a.H6))))"
    },
    "T6121": {
        "gap": "Tracking / visual processing issues make it difficult  to read the screen ",
        "job_group": "equipment",
        "prob_bit": 21,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6121",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3 || a.V4 || a.C1 || a.C6)) || ((a.V3 || a.C1 || a.C6) && (!a.V4)) || ((a.V3 || a.V4 || a.C1 || a.C6) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T6122": {
        "gap": "Only part of the screen is visible due to visual field deficit",
        "job_group": "equipment",
        "prob_bit": 22,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6122",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V4)) || ((a.V4) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T6123": {
        "gap": "Color, contrast, and/or glare makes screen difficult to see or causes eye strain  ",
        "job_group": "equipment",
        "prob_bit": 23,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6123",
        "trigger": "(a.equipment && a.using_a_computer && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V3 || a.C6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V3 || a.C6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V3)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V3 || a.C6) && (!a.V6) && (!a.H5) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V3) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T6124": {
        "gap": "Small size makes screen difficult to see or causes eye strain",
        "job_group": "equipment",
        "prob_bit": 24,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6124",
        "trigger": "(a.equipment && a.using_a_computer && (((a.V3)) || ((a.V3) && (!a.V6) && (!a.H5) && (!a.H6))))"
    },
    "T6125": {
        "gap": "Information cannot be seen at all",
        "job_group": "equipment",
        "prob_bit": 25,
        "task": "Using a Computer",
        "task_bit": 61,
        "task_code": "T6125",
        "trigger": "(a.equipment && a.using_a_computer && (((!a.V6) && (!a.H5) && (!a.H6)) || ((a.V6 || a.H6))))"
    },
    "T7301": {
        "gap": "Items are too heavy / bulky to carry",
        "job_group": "handling_materials",
        "prob_bit": 1,
        "task": "Carrying Materials",
        "task_bit": 73,
        "task_code": "T7301",
        "trigger": "(a.handling_materials && a.carrying_materials && (((a.L4 || a.L5 || a.L8a || a.U1 || a.U4 || a.U5))))"
    },
    "T7302": {
        "gap": "Person has difficulty with balance when carrying",
        "job_group": "handling_materials",
        "prob_bit": 2,
        "task": "Carrying Materials",
        "task_bit": 73,
        "task_code": "T7302",
        "trigger": "(a.handling_materials && a.carrying_materials && (((a.L4 || a.L8a))))"
    },
    "T7303": {
        "gap": "Person does not have free hands (e.g., using mobility aid)",
        "job_group": "handling_materials",
        "prob_bit": 3,
        "task": "Carrying Materials",
        "task_bit": 73,
        "task_code": "T7303",
        "trigger": "(a.handling_materials && a.carrying_materials && (((a.L8b || a.L8c || a.L8d || a.L8e))))"
    },
    "T8101": {
        "gap": "Managing Anxiety, Stress, or Emotions",
        "job_group": "wellbeing",
        "prob_bit": 1,
        "task": "Maintaining Well-Being",
        "task_bit": 81,
        "task_code": "T8101",
        "trigger": "(a.wellbeing && a.maintaining_wellbeing && (((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.U1) && (!a.U2) && (!a.U3) && (!a.U6) && (!a.U7) && (!a.U8) && (!a.U9)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V5) && (!a.V6) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.H1 || a.H2 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.V3) && (!a.V4) && (!a.V5) && (!a.V6) && (!a.H3) && (!a.H4) && (!a.H5) && (!a.H6)) || ((a.L1 || a.L2 || a.L3 || a.L4 || a.L5 || a.L6 || a.L7 || a.L8a || a.L8b || a.L8c || a.L8d || a.L8e || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U10 || a.U13 || a.U14 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.U11) && (!a.U12) && (!a.U15) && (!a.U16) && (!a.U17) && (!a.U18)) || ((a.L1 || a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1) && (!a.L3) && (!a.L4) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e)) || ((!a.L3) && (!a.L4) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e) && (a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1)) || ((!a.L7) && (!a.L8a) && (!a.L8b) && (!a.L8c) && (!a.L8d) && (!a.L8e) && (a.U1 || a.U2 || a.U3 || a.U4 || a.U5 || a.U6 || a.U7 || a.U8 || a.U9 || a.U10 || a.U11 || a.U12 || a.U13 || a.U14 || a.U15 || a.U16 || a.U17 || a.U18 || a.V1 || a.V2 || a.V3 || a.V4 || a.V5 || a.V6 || a.H1 || a.H2 || a.H3 || a.H4 || a.H5 || a.H6 || a.S1 || a.S2 || a.S3 || a.S4 || a.S5 || a.C1 || a.C2 || a.C3 || a.C4 || a.C5 || a.C6 || a.C7 || a.C8 || a.A1))))"
    }
}
export default job_rules;